import React from 'react'
import dayjs from 'dayjs'

//Components
import AttachmentPreview from 'components/attachment'

import styles from './index.module.scss'

function DemandsVersionController({ attachments }) {
	function handleDownloadAttachment(url, originalName) {
		if (!url) return
		const link = document.createElement('a')
		link.href = url
		link.setAttribute('download', originalName)
		link.target = '_blank'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	return (
		<div className={styles.detailsContainer}>
			<h3 className={styles.sectionTitle}>Controle de versões</h3>

			<section className={styles.versionList}>
				{attachments?.map((a) => (
					<div key={a.id} className={styles.versionItem}>
						<div className={styles.versionItemInfoContent}>
							<div className={styles.versionHeader}>
								<h4>V{a.version_number}</h4>
								<span className={styles.versionDate}>
									{a.created_at &&
										dayjs(a.created_at).format('DD/MM/YYYY [às] HH:mm')}
								</span>
							</div>
							<p>Versão</p>
						</div>
						<AttachmentPreview
							key={a.id}
							attachment={a}
							onDownload={() =>
								handleDownloadAttachment(a.url, a.original_name)
							}
						/>
					</div>
				))}
			</section>
		</div>
	)
}

export default DemandsVersionController
